<ng-container *ngIf="enabled$ | async">
  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button
      color="primary"
      (click)="scan()"
      [disabled]="scanning"
      title="Scan por câmara"
    >
      <ion-icon [name]="scanning ? 'hourglass-outline' : 'camera-outline'"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ng-container>
